import styled from 'styled-components';

export const Container = styled.div`
  padding: 24px 0 40px;

  .pi-error {
    margin-top: 16px;
  }

  .save-toast {
    position: fixed;
    top: 72px;
    right: 18px;
    z-index: 2000;
    box-shadow: 0 8px 28px rgba(33, 53, 74, 0.18);
    display: flex;
    align-items: center;
    gap: 8px;

    i {
      font-size: 18px;
    }

    a {
      font-weight: 700;
    }
  }

  .active-item {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 14px;
    padding: 8px 12px;
    border-radius: 10px;
    border: 1px solid ${(props) => props.theme.$secondary_green_light};
    background: ${(props) => props.theme.$bg_green};
    font-size: 0.84rem;
    color: ${(props) => props.theme.$gray700};

    > i {
      font-size: 18px;
      color: ${(props) => props.theme.$primary_green};
    }

    span {
      flex: 1;
      min-width: 0;
    }

    button {
      border: 0;
      background: transparent;
      padding: 2px;
      color: ${(props) => props.theme.$gray500};
      display: inline-flex;

      &:hover {
        color: ${(props) => props.theme.$gray900};
      }

      i {
        font-size: 17px;
      }
    }
  }

  .empty-state {
    margin-top: 48px;
    text-align: center;

    .empty-icon {
      width: 72px;
      height: 72px;
      border-radius: 18px;
      margin: 0 auto;
      background: ${(props) => props.theme.$bg_green};
      border: 1px solid ${(props) => props.theme.$secondary_green_light};
      color: ${(props) => props.theme.$primary_green};
      display: flex;
      align-items: center;
      justify-content: center;

      i {
        font-size: 34px;
      }
    }

    h5 {
      margin-top: 16px;
      font-weight: 700;
      color: ${(props) => props.theme.$gray900};
    }

    p {
      max-width: 520px;
      margin: 6px auto 0;
      font-size: 0.9rem;
      color: ${(props) => props.theme.$gray600};
    }

    .btn-link {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      margin-top: 10px;
      font-size: 0.88rem;
      color: ${(props) => props.theme.$dark_green};

      i {
        font-size: 18px;
      }
    }
  }
`;
